var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talk-bubble",class:{
        top: _vm.arrow !== 'bottom' && _vm.arrow !== 'left' && _vm.arrow !== 'right', // Default Top
        bottom: _vm.arrow === 'bottom',
        left: _vm.arrow === 'left',
        right: _vm.arrow === 'right',
    },style:({
        '--xy': _vm.adjustedPostition ? _vm.adjustedPostition : '50%',
        '--bgColor': _vm.bgColor ? _vm.bgColor : 'rgba(0, 0, 0, 0.03)',
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }